"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCESS_CONTROLS_PERMISSIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACCESS_CONTROLS_PERMISSIONS;
  }
});
Object.defineProperty(exports, "ACTIVITIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ACTIVITIES;
  }
});
Object.defineProperty(exports, "AUDIT_TRAIL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUDIT_TRAIL;
  }
});
Object.defineProperty(exports, "BUSINESS_PROCESS_AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BUSINESS_PROCESS_AUTOMATION;
  }
});
Object.defineProperty(exports, "CALENDAR_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CALENDAR_MANAGEMENT;
  }
});
Object.defineProperty(exports, "COMPLIANCE_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.COMPLIANCE_TRACKING;
  }
});
Object.defineProperty(exports, "CUSTOMIZABLE_DASHBOARD", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMIZABLE_DASHBOARD;
  }
});
Object.defineProperty(exports, "DEPENDENCIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DEPENDENCIES;
  }
});
Object.defineProperty(exports, "DOCUMENT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DOCUMENT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "FLOWS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FLOWS;
  }
});
Object.defineProperty(exports, "FORMS_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.FORMS_MANAGEMENT;
  }
});
Object.defineProperty(exports, "GRAPHICAL_WORKFLOW_EDITOR", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.GRAPHICAL_WORKFLOW_EDITOR;
  }
});
Object.defineProperty(exports, "INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.INTEGRATION;
  }
});
Object.defineProperty(exports, "KPI_BASED_REPORTS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.KPI_BASED_REPORTS;
  }
});
Object.defineProperty(exports, "MOBILE_ACCESS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MOBILE_ACCESS;
  }
});
Object.defineProperty(exports, "NOTIFICATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.NOTIFICATIONS;
  }
});
Object.defineProperty(exports, "ROLE_BASED_ACCESS_CONTROL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ROLE_BASED_ACCESS_CONTROL;
  }
});
Object.defineProperty(exports, "SLA_STATUS_INDICATORS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SLA_STATUS_INDICATORS;
  }
});
Object.defineProperty(exports, "TASK_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.TASK_MANAGEMENT;
  }
});
Object.defineProperty(exports, "THIRD_PARTY_INTEGRATIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.THIRD_PARTY_INTEGRATIONS;
  }
});
Object.defineProperty(exports, "UPDATES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.UPDATES;
  }
});
Object.defineProperty(exports, "WORKFLOW_CONFIGURATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WORKFLOW_CONFIGURATION;
  }
});
Object.defineProperty(exports, "WYSIWYG_FORM_DESIGNER", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WYSIWYG_FORM_DESIGNER;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Workflow.js
// module id = 589
// module chunks = 209 210 211 212 213